// Libs
import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import ReportsApi from "../api/Reports";
import { setErrors, setIsLoading } from "../utils/Actions";
import { useGlobalValue } from "../utils/GlobalState";
import LoginApi from "../api/Login";

export default function DownloadInvoiceModal(props) {
    const [, dispatch] = useGlobalValue();
    const [email, setEmail] = useState('');
    const [sendByEmail, setSendByEmail] = useState(false);
    const [emailSentSuccessfully, setEmailSentSuccessfully] = useState(false);
    const [emailSentFailed, setEmailSentFailed] = useState(false);
    const report = props.url;

    const emailReport = () => {
        const subject = 'Meal Ordering - Order Summary';
        const body = 'Here is your attachment.';

        ReportsApi.emailReport(report, email, subject, body).then(response => {
            let successfulEmails = response.emailResults.success;

            //confirm email recipient is in the list of success emails
            if (Array.isArray(successfulEmails) && successfulEmails.includes(email)) {
                setEmailSentSuccessfully(true)
                setEmailSentFailed(false)
            } else {
                setEmailSentSuccessfully(false)
                setEmailSentFailed(true)
            }
        }).catch(apiErrors => {
            setErrors(apiErrors, dispatch);
            setIsLoading(false, dispatch);
        })
    }

    const handleSendByEmailCheck = (e) => {
        setSendByEmail(e.target.checked)

        if (e.target.checked && email === '') {
            //fetch user email to pre-fill the input
            LoginApi.fetchClientUserEmail().then(response => {
                if (response.client.email) {
                    setEmail(response.client.email)
                }
            }).catch(apiErrors => {
                setErrors(apiErrors, dispatch);
                setIsLoading(false, dispatch);
            })
        }
    }

    if (!report) {
        return <></>;
    }

  return (
    <Modal show={props.show} onHide={props.hide} centered>
        <Modal.Header closeButton>
            <Modal.Title>Download</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Your file is ready to be downloaded! There's also an option to send by email if needed.

            <Form.Check id="send-by-email-checkbox" label="Send by email?" className="mt-3" type="checkbox" checked={sendByEmail} onChange={handleSendByEmailCheck}/>

            { sendByEmail && (
                <Row className="my-3">
                    <Form.Group as={Col} md="12" controlId="recipientEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            required
                            type="email"
                            readOnly
                            disabled
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            isValid={emailSentSuccessfully}
                            isInvalid={emailSentFailed}
                        />
                        <Form.Control.Feedback>Email sent successfully!</Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid">Email not sent! An error occurred, please check your email and try again.</Form.Control.Feedback>
                        <Form.Text muted>
                            Please check your email address before mailing the file. If it's incorrect, get in touch with us to update your profile.
                        </Form.Text>
                    </Form.Group>
                </Row>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="success" href={report} target="_blank" rel="noopener noreferrer">Download</Button>
            { sendByEmail && (<Button variant="primary" onClick={emailReport} disabled={(!sendByEmail || email === '')}>Email PDF/Report</Button>)}
            <Button variant="secondary" onClick={props.hide}>Close</Button>
        </Modal.Footer>
    </Modal>
  );
}
